import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, SelectProps } from '@mui/material'


export interface OptionList {
    value : string | number;
    label : string;
    disable?: boolean;
    message?: string;
}

export type SelectInputProps = SelectProps<any> &{
    handleChange: (value: any) => void;
    value?: any;
    options?: OptionList[],
    label: string;
}

export default function SelectInput({ handleChange, value, options, label, ...other}: SelectInputProps) {
    const handleChangeSelect = (event: SelectChangeEvent) => {
        handleChange(event.target.value as any);
      };
  return (
    <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            label={label}
            onChange={handleChangeSelect}
            {...other}
        >
            {options?.map(option => (
                <MenuItem value={option.value} disabled ={option.disable}>
                   
                    <>{option.label}  {option.message && <>- {option.message}</>}</>
            
                </MenuItem>
            ))}
        </Select>
    </FormControl>
  )
}
